// extracted by extract-css-chunks-webpack-plugin
module.exports = {"menu":"menu_gj++B"};